<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body" style="overflow: hidden">
            <vue-seamless-scroll :data="list" class="seamless-warp" :class-option="classOption">
                <ul>
                    <li class="list-row" v-for="(item,index) in list" :key="index">
                        <div class="list-item flex-center" style="width: 30px;flex: none;padding: 5px">
                            <div class="fill-cicle"></div>
                        </div>
                        <div class="list-item" style="width: 80px;flex: none">
                            {{typeNameObj[item.name]}}
                            
                        </div>
                        <div class="list-item" :title="item.value">{{item.value}}{{unitNameObj[item.name]}}</div>
                        <div class="list-item" :title="item.sysTime">{{item.sysTime}}</div>
                        
                    </li>
                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { getAction } from '@/api/manage'
import moment from 'moment'
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    components: {
        vueSeamlessScroll
    },
    data() {
        return {
            title: this.$t('实时告警'),
            typeNameObj: {'w01001-Rtd': this.$t('酸碱度'),'w01006-Rtd':this.$t('溶解性总固体'),'w10000-Rtd':this.$t('硬度'),'w01002-Rtd': this.$t('色度'),'w01003-Rtd':this.$t('浊度'),'w21022-Rtd': this.$t('氯化物'),'w10001-Rtd':'ORP','w21038-Rtd':this.$t('硫酸盐'),'w01019-Rtd':this.$t('高锰酸盐')},
            unitNameObj: {'w01001-Rtd': 'PH','w01006-Rtd':'mg/L','w10000-Rtd':'mg/L','w01002-Rtd': this.$t('度'),'w01003-Rtd':'NTU','w21022-Rtd': 'mg/L','w10001-Rtd':'mv','w21038-Rtd':'mg/L','w01019-Rtd':'mg/L'},
            list: [],
            url:{
                //OnTimeIndexStatistical:"/wq/wQDataRecord/queryOnTimeIndexStatistical"
                OnTimeIndexStatistical: '/jeecg-charge/part/partWaterQualityLastWarnRecord/list'
            },
            updateTime:''
        }
    },
    mounted() {
        
    },
    methods: {
        init() {
            this.resetData()
            this.queryOnTimeIndexStatistical()
        },
        resetData() {
            this.list = this.$options.data.call(this).list
        },
        // queryOnTimeIndexStatistical() {
        //     let params = {}
            
        //     postAction(this.url.OnTimeIndexStatistical, params).then((res) => {
        //     if(res.success){
        //         this.OnTimeIndexStatistical = res.result[0];
        //         console.log(this.OnTimeIndexStatistical);
        //         let updateTime = moment(this.OnTimeIndexStatistical.updateTime).format('MM-DD hh:mm:ss');
        //         console.log(this.updateTime);
        //         // if(this.OnTimeIndexStatistical.ph > JSON.parse(this.OnTimeIndexStatistical.remark).ec_down && this.OnTimeIndexStatistical.ph < JSON.parse(this.OnTimeIndexStatistical.remark).ec_up==false) {
                    
        //         // }
        //         let arr = [
        //             {name: '',type: 1,time: updateTime,number: this.OnTimeIndexStatistical.ph +"(PH)"},
        //             {name: '',type: 2,time: updateTime,number: this.OnTimeIndexStatistical.temp+"(℃)"},
        //             {name: '',type: 3,time: updateTime,number: this.OnTimeIndexStatistical.ss+"(NTU)"},
        //             {name: '',type: 4,time: updateTime,number: this.OnTimeIndexStatistical.fcl+"(mg/L)"},
        //             {name: '',type: 5,time: updateTime,number: this.OnTimeIndexStatistical.doo+"(mg/L)"},
        //             {name: '',type: 6,time: updateTime,number: this.OnTimeIndexStatistical.orp+"(mv)"},
        //             {name: '',type: 7,time: updateTime,number: this.OnTimeIndexStatistical.ec+"(mS/cm)"},
        //             {name: '',type: 8,time: updateTime,number: this.OnTimeIndexStatistical.nh3n+"(mg/L)"},
        //             {name: '',type: 9,time: updateTime,number: this.OnTimeIndexStatistical.chemo+"(mg/L)"}
        //         ]
        //         this.list = arr;
        //     }
        //     }) 
        // },
        queryOnTimeIndexStatistical() {
            let params = {}
            
            getAction(this.url.OnTimeIndexStatistical, params).then((res) => {
            if(res.success){
                let dataSource = res.result.records;
                this.list = dataSource;
            }
            }) 
        },
    },
    computed: {
        classOption() {
            return {
                step: 0.5, // 数值越大速度滚动越快
                limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    },
}
</script>
<style scoped>
.list-row{
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 35px;
}
.list-row .list-item{
    flex: 1;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    padding-right: 10px;
    color: #9DB9F6;
    font-size: 14px;

}
.fill-cicle{
    height: 10px;
    width: 10px;
    border-radius: 10px;
    background: red;
    box-shadow: 0 0 5px 5px rgba(255,0,0,.5);
}
ul{
    padding-inline-start: 0;
}
.seamless-warp{
    height: 100%;
}
.seamless-warp:hover{
    overflow-y: scroll;
}
.seamless-warp::-webkit-scrollbar{
    width:6px;
    height:6px;
}
.seamless-warp::-webkit-scrollbar-track{
    background: #0E0C4F;
    border-radius:2px;
}
.seamless-warp::-webkit-scrollbar-thumb{
    background:#292F88;
    border-radius:2px;
}
.seamless-warp::-webkit-scrollbar-corner {
    background: #0E0C4F;
}
</style>